// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as List from "rescript/lib/es6/list.js";
import * as $$Array from "rescript/lib/es6/array.js";
import * as $$String from "rescript/lib/es6/string.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";

var questionMarkingSchema = S.union([
      S.literal("QuestionMarking"),
      S.literal("ResponseMarking"),
      S.literal("ResponseMarkingWithDistractors"),
      S.literal("AnswerSetMarkingPointPerSetWithDistractors"),
      S.literal("AnswerSetMarkingWithDistractors")
    ]);

function responseIdentifiersMatch(responseIdentifier1, responseIdentifier2) {
  switch (responseIdentifier1.TAG) {
    case "SingleId" :
        if (responseIdentifier2.TAG === "SingleId") {
          return responseIdentifier1._0 === responseIdentifier2._0;
        } else {
          return false;
        }
    case "Index" :
        return false;
    case "IdPair" :
        if (responseIdentifier2.TAG === "IdPair") {
          return responseIdentifier1._0 === responseIdentifier2._0;
        } else {
          return false;
        }
    case "Group" :
        var match = responseIdentifier1._1;
        var g1 = responseIdentifier1._0;
        if (match.TAG === "Index") {
          if (responseIdentifier2.TAG !== "Group") {
            return false;
          }
          var match$1 = responseIdentifier2._1;
          if (match$1.TAG === "Index" && g1 === responseIdentifier2._0) {
            return match._0 === match$1._0;
          }
          
        }
        if (responseIdentifier2.TAG === "Group") {
          return g1 === responseIdentifier2._0;
        } else {
          return false;
        }
        break;
    case "AnswerSet" :
        var id1 = responseIdentifier1._1;
        if (id1.TAG !== "SingleId") {
          return false;
        }
        if (responseIdentifier2.TAG !== "AnswerSet") {
          return false;
        }
        var id2 = responseIdentifier2._1;
        if (id2.TAG === "SingleId") {
          return id1._0 === id2._0;
        } else {
          return false;
        }
    
  }
}

function responseTypeExists(responses, responsePayload) {
  return $$Array.fold_left((function (acc, response) {
                if (acc) {
                  return acc;
                } else {
                  return responseIdentifiersMatch(responsePayload._0, response._0._0);
                }
              }), false, responses);
}

function toggleIfMatch(responseIdentifier, existingResponsePayload, toggleResponsePayload) {
  var existingResponseIdentifier = existingResponsePayload._0;
  switch (responseIdentifier.TAG) {
    case "SingleId" :
        if (existingResponseIdentifier.TAG === "SingleId") {
          if (responseIdentifier._0 === existingResponseIdentifier._0) {
            return [];
          } else {
            return [{
                      TAG: "ToggleResponse",
                      _0: existingResponsePayload
                    }];
          }
        } else {
          return [{
                    TAG: "ToggleResponse",
                    _0: existingResponsePayload
                  }];
        }
    case "Index" :
        return [{
                  TAG: "ToggleResponse",
                  _0: existingResponsePayload
                }];
    case "IdPair" :
        if (existingResponseIdentifier.TAG === "IdPair") {
          if (responseIdentifier._0 === existingResponseIdentifier._0) {
            return [];
          } else {
            return [{
                      TAG: "ToggleResponse",
                      _0: existingResponsePayload
                    }];
          }
        } else {
          return [{
                    TAG: "ToggleResponse",
                    _0: existingResponsePayload
                  }];
        }
    case "Group" :
        var id1 = responseIdentifier._1;
        var g1 = responseIdentifier._0;
        switch (id1.TAG) {
          case "SingleId" :
              if (existingResponseIdentifier.TAG !== "Group") {
                return [{
                          TAG: "ToggleResponse",
                          _0: existingResponsePayload
                        }];
              }
              var id2 = existingResponseIdentifier._1;
              if (id2.TAG === "SingleId") {
                if (g1 === existingResponseIdentifier._0) {
                  if (id1._0 === id2._0) {
                    return [];
                  } else {
                    return [{
                              TAG: "ToggleResponse",
                              _0: toggleResponsePayload
                            }];
                  }
                } else {
                  return [{
                            TAG: "ToggleResponse",
                            _0: existingResponsePayload
                          }];
                }
              } else {
                return [{
                          TAG: "ToggleResponse",
                          _0: existingResponsePayload
                        }];
              }
          case "IdPair" :
              if (existingResponseIdentifier.TAG !== "Group") {
                return [{
                          TAG: "ToggleResponse",
                          _0: existingResponsePayload
                        }];
              }
              var match = existingResponseIdentifier._1;
              if (match.TAG === "IdPair") {
                if (g1 === existingResponseIdentifier._0) {
                  if (id1._0 === match._0) {
                    return [];
                  } else {
                    return [{
                              TAG: "ToggleResponse",
                              _0: toggleResponsePayload
                            }];
                  }
                } else {
                  return [{
                            TAG: "ToggleResponse",
                            _0: existingResponsePayload
                          }];
                }
              } else {
                return [{
                          TAG: "ToggleResponse",
                          _0: existingResponsePayload
                        }];
              }
          default:
            return [{
                      TAG: "ToggleResponse",
                      _0: existingResponsePayload
                    }];
        }
    case "AnswerSet" :
        var id1$1 = responseIdentifier._1;
        if (id1$1.TAG !== "SingleId") {
          return [{
                    TAG: "ToggleResponse",
                    _0: existingResponsePayload
                  }];
        }
        if (existingResponseIdentifier.TAG !== "AnswerSet") {
          return [{
                    TAG: "ToggleResponse",
                    _0: existingResponsePayload
                  }];
        }
        var id2$1 = existingResponseIdentifier._1;
        if (id2$1.TAG === "SingleId") {
          if (id1$1._0 === id2$1._0) {
            return [];
          } else {
            return [{
                      TAG: "ToggleResponse",
                      _0: existingResponsePayload
                    }];
          }
        } else {
          return [{
                    TAG: "ToggleResponse",
                    _0: existingResponsePayload
                  }];
        }
    
  }
}

function toggleResponse(responses, toggleResponsePayload) {
  var responseIdentifier = toggleResponsePayload._0;
  if (responseTypeExists(responses, toggleResponsePayload)) {
    return $$Array.fold_left((function (acc, existingResponse) {
                  if (existingResponse.TAG !== "ToggleResponse") {
                    return $$Array.append(acc, [existingResponse]);
                  }
                  var item = toggleIfMatch(responseIdentifier, existingResponse._0, toggleResponsePayload);
                  return $$Array.append(acc, item);
                }), [], responses);
  } else {
    return $$Array.append(responses, [{
                  TAG: "ToggleResponse",
                  _0: toggleResponsePayload
                }]);
  }
}

function setIfMatch(responseIdentifier, existingResponsePayload, responsePayload, existingResponse) {
  var existingResponseIdentifier = existingResponsePayload._0;
  switch (responseIdentifier.TAG) {
    case "SingleId" :
        if (existingResponseIdentifier.TAG === "SingleId") {
          if (responseIdentifier._0 === existingResponseIdentifier._0) {
            return [{
                      TAG: "SetResponse",
                      _0: responsePayload
                    }];
          } else {
            return [existingResponse];
          }
        } else {
          return [existingResponse];
        }
    case "IdPair" :
        if (existingResponseIdentifier.TAG === "IdPair") {
          if (responseIdentifier._0 === existingResponseIdentifier._0) {
            return [{
                      TAG: "SetResponse",
                      _0: responsePayload
                    }];
          } else {
            return [existingResponse];
          }
        } else {
          return [existingResponse];
        }
    case "Group" :
        var id1 = responseIdentifier._1;
        var g1 = responseIdentifier._0;
        switch (id1.TAG) {
          case "SingleId" :
              if (existingResponseIdentifier.TAG !== "Group") {
                return [existingResponse];
              }
              var id2 = existingResponseIdentifier._1;
              if (id2.TAG === "SingleId") {
                if (g1 === existingResponseIdentifier._0) {
                  if (id1._0 === id2._0) {
                    return [{
                              TAG: "SetResponse",
                              _0: responsePayload
                            }];
                  } else {
                    return [existingResponse];
                  }
                } else {
                  return [existingResponse];
                }
              } else {
                return [existingResponse];
              }
          case "Index" :
              if (existingResponseIdentifier.TAG !== "Group") {
                return [existingResponse];
              }
              var match = existingResponseIdentifier._1;
              if (match.TAG === "Index") {
                if (g1 === existingResponseIdentifier._0 && id1._0 === match._0) {
                  return [{
                            TAG: "SetResponse",
                            _0: responsePayload
                          }];
                } else {
                  return [existingResponse];
                }
              } else {
                return [existingResponse];
              }
          case "IdPair" :
              if (existingResponseIdentifier.TAG !== "Group") {
                return [existingResponse];
              }
              var match$1 = existingResponseIdentifier._1;
              if (match$1.TAG === "IdPair") {
                if (g1 === existingResponseIdentifier._0) {
                  if (id1._0 === match$1._0) {
                    return [{
                              TAG: "SetResponse",
                              _0: responsePayload
                            }];
                  } else {
                    return [existingResponse];
                  }
                } else {
                  return [existingResponse];
                }
              } else {
                return [existingResponse];
              }
          case "Group" :
          case "AnswerSet" :
              return [existingResponse];
          
        }
    case "Index" :
    case "AnswerSet" :
        return [existingResponse];
    
  }
}

function setResponse(responses, strResponsePayload) {
  var responseIdentifier = strResponsePayload._0;
  if (responseTypeExists(responses, strResponsePayload)) {
    return $$Array.fold_left((function (acc, existingResponse) {
                  if (existingResponse.TAG === "ToggleResponse") {
                    throw {
                          RE_EXN_ID: "Match_failure",
                          _1: [
                            "Reducer.res",
                            207,
                            10
                          ],
                          Error: new Error()
                        };
                  }
                  var item = setIfMatch(responseIdentifier, existingResponse._0, strResponsePayload, existingResponse);
                  return $$Array.append(acc, item);
                }), [], responses);
  } else {
    return $$Array.append(responses, [{
                  TAG: "SetResponse",
                  _0: strResponsePayload
                }]);
  }
}

function updateQuestion(responses, response, questionMarking) {
  var tmp;
  if (responses.length !== 0) {
    var tmp$1;
    tmp$1 = response.TAG === "ToggleResponse" ? toggleResponse(responses, response._0) : setResponse(responses, response._0);
    tmp = {
      TAG: "QuestionAttempted",
      _0: tmp$1,
      _1: questionMarking
    };
  } else {
    tmp = {
      TAG: "QuestionAttempted",
      _0: [response],
      _1: questionMarking
    };
  }
  if (typeof tmp !== "object" || !Caml_obj.equal(tmp._0, [])) {
    return tmp;
  } else {
    return "NotAttempted";
  }
}

function respondToQuestion(questionState, response, questionMarking) {
  if (typeof questionState !== "object") {
    return updateQuestion([], response, questionMarking);
  } else {
    return updateQuestion(questionState._0, response, questionMarking);
  }
}

var splitChar = "<>";

function joinIdPair(id1, id2) {
  return id1 + (splitChar + id2);
}

function splitAnswerAtIndex(answer) {
  var match = answer.split(/^\^\[(\d+)\]\^(.*)$/);
  if (match.length !== 4) {
    return ;
  }
  var index = match[1];
  if (index === undefined) {
    return ;
  }
  var id = match[2];
  if (id !== undefined) {
    return Belt_Option.flatMap(Belt_Int.fromString(index), (function (index) {
                  return [
                          index,
                          id
                        ];
                }));
  }
  
}

function joinIndexPair(index, id2) {
  return "^[" + String(index) + "]^" + id2;
}

var answerSetChar = ">>>";

function joinAnswerSetPair(setName, id2) {
  return setName + (answerSetChar + id2);
}

function extractAnswer(response) {
  if (response.TAG === "ToggleResponse") {
    var responseIdentifier = response._0._0;
    switch (responseIdentifier.TAG) {
      case "SingleId" :
          return responseIdentifier._0;
      case "Index" :
          return ;
      case "IdPair" :
          return joinIdPair(responseIdentifier._0, responseIdentifier._1);
      case "Group" :
          var id = responseIdentifier._1;
          switch (id.TAG) {
            case "SingleId" :
                return id._0;
            case "IdPair" :
                return joinIdPair(id._0, id._1);
            default:
              return ;
          }
      case "AnswerSet" :
          var id$1 = responseIdentifier._1;
          if (id$1.TAG === "SingleId") {
            return joinAnswerSetPair(responseIdentifier._0, id$1._0);
          } else {
            return ;
          }
      
    }
  } else {
    var responsePayload = response._0;
    if (responsePayload.TAG === "BoolResponsePayload") {
      var responseIdentifier$1 = responsePayload._0;
      switch (responseIdentifier$1.TAG) {
        case "SingleId" :
            return responseIdentifier$1._0;
        case "IdPair" :
            return joinIdPair(responseIdentifier$1._0, responseIdentifier$1._1);
        case "Group" :
            var id$2 = responseIdentifier$1._1;
            switch (id$2.TAG) {
              case "SingleId" :
                  return id$2._0;
              case "Index" :
                  var match = id$2._1;
                  if (match.TAG === "IdPair") {
                    return joinIdPair(match._0, joinIndexPair(id$2._0, match._1));
                  } else {
                    return ;
                  }
              case "IdPair" :
                  return joinIdPair(id$2._0, id$2._1);
              case "Group" :
              case "AnswerSet" :
                  return ;
              
            }
        case "Index" :
        case "AnswerSet" :
            return ;
        
      }
    } else {
      var responseIdentifier$2 = responsePayload._0;
      if (responseIdentifier$2.TAG === "SingleId") {
        return responseIdentifier$2._0 + (":" + $$String.trim(responsePayload._1));
      } else {
        return ;
      }
    }
  }
}

function extractAnswers(responses) {
  return $$Array.fold_left((function (acc, response) {
                var answer = extractAnswer(response);
                if (answer !== undefined) {
                  return List.append(acc, {
                              hd: answer,
                              tl: /* [] */0
                            });
                } else {
                  return acc;
                }
              }), /* [] */0, responses);
}

function diff(xs, xss) {
  return List.fold_left((function (acc, el) {
                if (List.exists((function (row) {
                          return Caml_obj.equal(row, el);
                        }), xss)) {
                  return acc;
                } else {
                  return List.append(acc, {
                              hd: el,
                              tl: /* [] */0
                            });
                }
              }), /* [] */0, xs);
}

var CantUseResponseMarkingWithDistractorsWithAnswerSet = /* @__PURE__ */Caml_exceptions.create("Reducer-LiteracyplanetTupperware.CantUseResponseMarkingWithDistractorsWithAnswerSet");

var CantUseAnswerSetMarkingPointPerSetWithDistractorsWithoutAnswerSet = /* @__PURE__ */Caml_exceptions.create("Reducer-LiteracyplanetTupperware.CantUseAnswerSetMarkingPointPerSetWithDistractorsWithoutAnswerSet");

var CantUseAnswerSetMarkingWithDistractorsWithoutAnswerSet = /* @__PURE__ */Caml_exceptions.create("Reducer-LiteracyplanetTupperware.CantUseAnswerSetMarkingWithDistractorsWithoutAnswerSet");

function markResponses(questionMarking, answer, usersAnswer) {
  var countResponsesCorrect = function (usersAnswer, answer) {
    return Belt_List.reduce(answer, 0, (function (count, a) {
                  return Belt_List.reduce(usersAnswer, count, (function (count, ua) {
                                if (ua === a) {
                                  return count + 1 | 0;
                                } else {
                                  return count;
                                }
                              }));
                }));
  };
  var isDistractorSelected = function (usersAnswer, answer) {
    return Belt_List.reduce(usersAnswer, false, (function (incorrect, ua) {
                  if (incorrect) {
                    return incorrect;
                  } else {
                    return !Belt_Array.some(Belt_List.toArray(answer), (function (a) {
                                  return a === ua;
                                }));
                  }
                }));
  };
  var makeSets = function (a) {
    return Belt_List.reduce(a, undefined, (function (acc, curr) {
                  var match = curr.split(">>>");
                  if (match.length !== 2) {
                    return acc;
                  }
                  var setId = match[0];
                  var d = acc !== undefined ? acc : ({});
                  var values = Belt_Option.getWithDefault(Js_dict.get(d, setId), /* [] */0);
                  d[setId] = Belt_List.concat(values, {
                        hd: curr,
                        tl: /* [] */0
                      });
                  return d;
                }));
  };
  switch (questionMarking) {
    case "QuestionMarking" :
        return [
                undefined,
                undefined
              ];
    case "ResponseMarking" :
        return [
                countResponsesCorrect(usersAnswer, answer),
                List.length(answer)
              ];
    case "ResponseMarkingWithDistractors" :
        var match = makeSets(answer);
        if (match !== undefined) {
          throw {
                RE_EXN_ID: CantUseResponseMarkingWithDistractorsWithAnswerSet,
                Error: new Error()
              };
        }
        if (isDistractorSelected(usersAnswer, answer)) {
          return [
                  0,
                  List.length(answer)
                ];
        } else {
          return [
                  countResponsesCorrect(usersAnswer, answer),
                  List.length(answer)
                ];
        }
    case "AnswerSetMarkingPointPerSetWithDistractors" :
        var answerSets = makeSets(answer);
        if (answerSets !== undefined) {
          var setIds = Object.keys(answerSets);
          var totalSets = setIds.length;
          var userAnswerSets = makeSets(usersAnswer);
          if (userAnswerSets === undefined) {
            return [
                    0,
                    totalSets
                  ];
          }
          var correctSets = Belt_Array.reduce(setIds, 0, (function (total, setId) {
                  var usersAnswer = Js_dict.get(userAnswerSets, setId);
                  var answer = answerSets[setId];
                  return Belt_Option.mapWithDefault(usersAnswer, total, (function (usersAnswer) {
                                if (isDistractorSelected(usersAnswer, answer) || !Belt_List.every(answer, (function (a) {
                                          return Belt_List.some(usersAnswer, (function (b) {
                                                        return a === b;
                                                      }));
                                        }))) {
                                  return total;
                                } else {
                                  return total + 1 | 0;
                                }
                              }));
                }));
          return [
                  correctSets,
                  totalSets
                ];
        }
        throw {
              RE_EXN_ID: CantUseAnswerSetMarkingPointPerSetWithDistractorsWithoutAnswerSet,
              Error: new Error()
            };
    case "AnswerSetMarkingWithDistractors" :
        var answerSets$1 = makeSets(answer);
        if (answerSets$1 !== undefined) {
          var setIds$1 = Object.keys(answerSets$1);
          var totalSets$1 = List.length(answer);
          var userAnswerSets$1 = makeSets(usersAnswer);
          if (userAnswerSets$1 === undefined) {
            return [
                    0,
                    totalSets$1
                  ];
          }
          var correctSets$1 = Belt_Array.reduce(setIds$1, 0, (function (total, setId) {
                  var usersAnswer = Js_dict.get(userAnswerSets$1, setId);
                  var answer = answerSets$1[setId];
                  return Belt_Option.mapWithDefault(usersAnswer, total, (function (usersAnswer) {
                                if (isDistractorSelected(usersAnswer, answer)) {
                                  return total;
                                } else {
                                  return Belt_List.reduce(answer, total, (function (total, a) {
                                                if (Belt_List.some(usersAnswer, (function (b) {
                                                          return a === b;
                                                        }))) {
                                                  return total + 1 | 0;
                                                } else {
                                                  return total;
                                                }
                                              }));
                                }
                              }));
                }));
          return [
                  correctSets$1,
                  totalSets$1
                ];
        }
        throw {
              RE_EXN_ID: CantUseAnswerSetMarkingWithDistractorsWithoutAnswerSet,
              Error: new Error()
            };
    
  }
}

function markQuestion(questionState, correctAnswer) {
  if (typeof questionState !== "object") {
    var answer = correctAnswer._0;
    return [
            false,
            {
              TAG: "BoolMarkState",
              _0: {
                questionCorrect: false,
                answer: answer,
                incorrectResponses: answer,
                responsesCorrect: undefined,
                responsesComplete: undefined
              }
            }
          ];
  }
  var questionMarking = questionState._1;
  var responses = questionState._0;
  if (correctAnswer.TAG === "AnswerExactMatch") {
    var answer$1 = correctAnswer._0;
    var usersAnswer = extractAnswers(responses);
    var incorrectResponses = List.append(diff(answer$1, usersAnswer), diff(usersAnswer, answer$1));
    var questionCorrect = List.length(incorrectResponses) === 0;
    var match = markResponses(questionMarking, answer$1, usersAnswer);
    var responsesComplete = match[1];
    var responsesCorrect = match[0];
    console.log(responsesCorrect, responsesComplete);
    return [
            questionCorrect,
            {
              TAG: "BoolMarkState",
              _0: {
                questionCorrect: questionCorrect,
                answer: answer$1,
                incorrectResponses: incorrectResponses,
                responsesCorrect: responsesCorrect,
                responsesComplete: responsesComplete
              }
            }
          ];
  }
  var answer$2 = correctAnswer._0;
  var usersAnswer$1 = extractAnswers(responses);
  var lowercaseUserAnswer = Belt_List.map(usersAnswer$1, $$String.lowercase_ascii);
  var lowercaseAnswers = Belt_List.map(answer$2, $$String.lowercase_ascii);
  var incorrectResponses$1 = List.append(diff(lowercaseAnswers, lowercaseUserAnswer), diff(lowercaseUserAnswer, lowercaseAnswers));
  var questionCorrect$1 = List.length(incorrectResponses$1) === 0;
  var match$1 = markResponses(questionMarking, lowercaseAnswers, lowercaseUserAnswer);
  var responsesComplete$1 = match$1[1];
  var responsesCorrect$1 = match$1[0];
  console.log(responsesCorrect$1, responsesComplete$1);
  return [
          questionCorrect$1,
          {
            TAG: "BoolMarkState",
            _0: {
              questionCorrect: questionCorrect$1,
              answer: answer$2,
              incorrectResponses: incorrectResponses$1,
              responsesCorrect: responsesCorrect$1,
              responsesComplete: responsesComplete$1
            }
          }
        ];
}

function getMarkType(step, responseOptionId) {
  if (typeof step !== "object" || step.TAG === "Attempted") {
    return "Unanswered";
  } else {
    var markState = step._0;
    if (typeof markState !== "object") {
      return "Unanswered";
    } else {
      var param = markState._0;
      if (List.exists((function (x) {
                return x === responseOptionId;
              }), param.incorrectResponses)) {
        return "Wrong";
      } else {
        return "Correct";
      }
    }
  }
}

function getMarkTypeWip(step, responseOptionId) {
  var compareToLeft = function (re, a) {
    var match = Js_string.splitByRe(re, a);
    if (match.length !== 2) {
      return false;
    }
    var left = match[0];
    if (left !== undefined) {
      return left === responseOptionId;
    } else {
      return false;
    }
  };
  var setComparators = function (ra) {
    return Belt_Array.map(ra, (function (r) {
                  var _ri = r._0._0;
                  while(true) {
                    var ri = _ri;
                    switch (ri.TAG) {
                      case "SingleId" :
                          return function (x) {
                            return compareToLeft(/\:/, x);
                          };
                      case "IdPair" :
                          return function (x) {
                            return compareToLeft(/\<\>/, x);
                          };
                      case "Group" :
                          _ri = ri._1;
                          continue ;
                      case "Index" :
                      case "AnswerSet" :
                          throw {
                                RE_EXN_ID: "Match_failure",
                                _1: [
                                  "Reducer.res",
                                  515,
                                  6
                                ],
                                Error: new Error()
                              };
                      
                    }
                  };
                }));
  };
  if (typeof step !== "object") {
    return "Unanswered";
  }
  if (step.TAG === "Attempted") {
    return "Unanswered";
  }
  var match = step._1;
  if (typeof match !== "object") {
    return "Wrong";
  } else {
    var ms = step._0;
    var ra = match._0;
    if (typeof ms !== "object") {
      return "Unanswered";
    } else {
      var param = ms._0;
      var incorrectResponses = param.incorrectResponses;
      var comparators = setComparators(ra);
      if (List.length(incorrectResponses) === 0) {
        return "Correct";
      } else {
        return List.fold_left((function (acc, ir) {
                      switch (acc) {
                        case "Wrong" :
                            return acc;
                        case "Correct" :
                        case "Unanswered" :
                            break;
                        
                      }
                      if ($$Array.fold_left((function (acc, comparator) {
                                return acc ? acc : comparator(ir);
                              }), false, comparators)) {
                        return "Wrong";
                      } else {
                        return "Correct";
                      }
                    }), "Correct", incorrectResponses);
      }
    }
  }
}

function buildResponseType(groupName, responseOptionId) {
  return {
          TAG: "ToggleResponse",
          _0: {
            TAG: "BoolResponsePayload",
            _0: groupName !== undefined ? ({
                  TAG: "Group",
                  _0: groupName,
                  _1: {
                    TAG: "SingleId",
                    _0: responseOptionId
                  }
                }) : ({
                  TAG: "SingleId",
                  _0: responseOptionId
                })
          }
        };
}

function buildAnswerSetResponseType(setName, responseOptionId) {
  return {
          TAG: "ToggleResponse",
          _0: {
            TAG: "BoolResponsePayload",
            _0: setName !== undefined ? ({
                  TAG: "AnswerSet",
                  _0: setName,
                  _1: {
                    TAG: "SingleId",
                    _0: responseOptionId
                  }
                }) : ({
                  TAG: "SingleId",
                  _0: responseOptionId
                })
          }
        };
}

function checkStep(questionState, markState) {
  if (typeof questionState !== "object") {
    if (typeof markState !== "object") {
      return "WaitingForUser";
    } else {
      return {
              TAG: "Marked",
              _0: markState,
              _1: questionState
            };
    }
  } else if (typeof markState !== "object") {
    return {
            TAG: "Attempted",
            _0: questionState
          };
  } else {
    return {
            TAG: "Marked",
            _0: markState,
            _1: questionState
          };
  }
}

function isMarked(step) {
  if (typeof step !== "object" || step.TAG === "Attempted") {
    return false;
  } else {
    return true;
  }
}

function getSingleId(responseIdentifier, text, responseOptionId) {
  if (responseIdentifier.TAG === "SingleId" && responseIdentifier._0 === responseOptionId) {
    return Caml_option.some(text);
  }
  
}

function getSetResponsePayload(responsePayload, responseOptionId) {
  if (responsePayload.TAG === "BoolResponsePayload") {
    return ;
  } else {
    return getSingleId(responsePayload._0, responsePayload._1, responseOptionId);
  }
}

function getSetResponse(response, responseOptionId) {
  if (response.TAG === "ToggleResponse") {
    return ;
  } else {
    return getSetResponsePayload(response._0, responseOptionId);
  }
}

function getResponse(responseArray, responseOptionId) {
  return Belt_Array.reduce(responseArray, "", (function (acc, response) {
                return Belt_Option.getWithDefault(getSetResponse(response, responseOptionId), acc);
              }));
}

function getAttempt(questionState, responseOptionId) {
  if (typeof questionState !== "object") {
    return "";
  } else {
    return getResponse(questionState._0, responseOptionId);
  }
}

function getStepResponseValue(step, responseOptionId) {
  if (typeof step !== "object") {
    return "";
  } else if (step.TAG === "Attempted") {
    return getAttempt(step._0, responseOptionId);
  } else {
    return getAttempt(step._1, responseOptionId);
  }
}

function findIdPair(test, questionState) {
  if (typeof questionState !== "object") {
    return ;
  } else {
    return Belt_Array.reduce(questionState._0, undefined, (function (acc, response) {
                  var responsePayload = response._0;
                  if (responsePayload.TAG === "BoolResponsePayload") {
                    var match = responsePayload._0;
                    if (match.TAG === "IdPair") {
                      var resId2 = match._1;
                      var resId1 = match._0;
                      if (test(resId1, resId2)) {
                        return [
                                resId1,
                                resId2
                              ];
                      } else {
                        return acc;
                      }
                    }
                    throw {
                          RE_EXN_ID: "Match_failure",
                          _1: [
                            "Reducer.res",
                            640,
                            8
                          ],
                          Error: new Error()
                        };
                  }
                  throw {
                        RE_EXN_ID: "Match_failure",
                        _1: [
                          "Reducer.res",
                          640,
                          8
                        ],
                        Error: new Error()
                      };
                }));
  }
}

function findIdPairWithGroup(test, questionState) {
  if (typeof questionState !== "object") {
    return ;
  } else {
    return Belt_Array.reduce(questionState._0, undefined, (function (acc, response) {
                  var responsePayload = response._0;
                  if (responsePayload.TAG === "BoolResponsePayload") {
                    var match = responsePayload._0;
                    if (match.TAG === "Group") {
                      var match$1 = match._1;
                      if (match$1.TAG === "IdPair") {
                        var resId2 = match$1._1;
                        var resId1 = match$1._0;
                        var group = match._0;
                        if (test(resId1, resId2, group)) {
                          return [
                                  resId1,
                                  resId2,
                                  group
                                ];
                        } else {
                          return acc;
                        }
                      }
                      
                    }
                    
                  }
                  throw {
                        RE_EXN_ID: "Match_failure",
                        _1: [
                          "Reducer.res",
                          657,
                          8
                        ],
                        Error: new Error()
                      };
                }));
  }
}

function findQuestionState(step) {
  if (typeof step !== "object") {
    return ;
  } else if (step.TAG === "Attempted") {
    return step._0;
  } else {
    return step._1;
  }
}

function mapIdPair(step, f) {
  return Belt_Option.flatMap(findQuestionState(step), (function (__x) {
                return findIdPair(f, __x);
              }));
}

function mapIdPairWithGroup(step, f) {
  return Belt_Option.flatMap(findQuestionState(step), (function (__x) {
                return findIdPairWithGroup(f, __x);
              }));
}

function mapDropId(idPair) {
  return Belt_Option.flatMap(idPair, (function (param) {
                return param[0];
              }));
}

function filterResponseIdentifier(questionState, identifier) {
  if (typeof questionState === "object") {
    return {
            TAG: "QuestionAttempted",
            _0: Belt_Array.reduce(questionState._0, [], (function (acc, response) {
                    if (Caml_obj.equal(response._0._0, identifier)) {
                      return acc;
                    } else {
                      return Belt_Array.concat(acc, [response]);
                    }
                  })),
            _1: questionState._1
          };
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "Reducer.res",
          694,
          2
        ],
        Error: new Error()
      };
}

export {
  questionMarkingSchema ,
  responseIdentifiersMatch ,
  responseTypeExists ,
  toggleIfMatch ,
  toggleResponse ,
  setIfMatch ,
  setResponse ,
  updateQuestion ,
  respondToQuestion ,
  splitChar ,
  joinIdPair ,
  splitAnswerAtIndex ,
  joinIndexPair ,
  answerSetChar ,
  joinAnswerSetPair ,
  extractAnswer ,
  extractAnswers ,
  diff ,
  CantUseResponseMarkingWithDistractorsWithAnswerSet ,
  CantUseAnswerSetMarkingPointPerSetWithDistractorsWithoutAnswerSet ,
  CantUseAnswerSetMarkingWithDistractorsWithoutAnswerSet ,
  markResponses ,
  markQuestion ,
  getMarkType ,
  getMarkTypeWip ,
  buildResponseType ,
  buildAnswerSetResponseType ,
  checkStep ,
  isMarked ,
  getSingleId ,
  getSetResponsePayload ,
  getSetResponse ,
  getResponse ,
  getAttempt ,
  getStepResponseValue ,
  findIdPair ,
  findIdPairWithGroup ,
  findQuestionState ,
  mapIdPair ,
  mapIdPairWithGroup ,
  mapDropId ,
  filterResponseIdentifier ,
}
/* questionMarkingSchema Not a pure module */
